import axios from 'axios';
import React from 'react';

const UserInfo = () => {
    const [userInfo, setUserinfo] = React.useState([]);

    React.useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_LINK}userInfo`).then(res => {
            setUserinfo(res.data);
        });
    }, []);
    return (
        <div className='h-100'>
            <section className=' px-4'>
                <div className='h-100'>
                    <div className='w-100 mx-auto bg-white shadow-lg rounded-sm '>
                        <header className='px-5 py-4 border-b border-gray-100'>
                            <h2 style={{ fontSize: "25px", fontWeight: "600", color: '#404040' }}>All Users Data</h2>
                        </header>
                        <div className='p-3'>
                            <div className='table-responsive'>
                                <table className='table w-100'>
                                    <thead
                                        style={{
                                            fontSize: "18px",
                                            color: "gray"
                                        }}>
                                        <tr>
                                            <th className='p-2'>
                                                <div>Name</div>
                                            </th>
                                            <th className='p-2'>
                                                <div >Email</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userInfo.map(userI => (
                                            <tr key={userI._id}>
                                                <td className='p-2'>
                                                    <div style={{ fontSize: '15px' }}>
                                                        {userI.name}
                                                    </div>
                                                </td>
                                                <td className='p-2'>
                                                    <div style={{ fontSize: '15px' }}>{userI.email}</div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default UserInfo;